import { Card } from '@/components/ui/card';
import { Tag } from '@/components/common/Tag';
import type { DebugErrorsDto } from '@/types/dto';

function fmtTime(iso: string): string {
  return new Date(iso).toLocaleString(undefined, {
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function ErrorLog({ data }: { data: DebugErrorsDto }) {
  return (
    <Card>
      <h2 className="text-xl font-semibold mb-1">Pipeline Errors (last 7 days)</h2>
      <p className="text-muted text-sm mb-3">
        Failed scrapes {data.failedScrapes} · failed Bright Data snapshots {data.failedSnapshots} ·
        blocked article fetches {data.blockedArticles} · failed API calls {data.failedApiCalls}.
        Unhandled runtime exceptions are not stored here — see App Insights / container logs.
      </p>
      {data.recent.length === 0 ? (
        <p className="text-muted">No pipeline errors in the last 7 days.</p>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b-2 border-accent">
              <Th>When</Th>
              <Th>Kind</Th>
              <Th>Source</Th>
              <Th>Detail</Th>
            </tr>
          </thead>
          <tbody>
            {data.recent.map((e, idx) => (
              <tr key={`${e.at}-${idx}`} className="border-b border-border align-top">
                <td className="py-2 px-3 text-muted whitespace-nowrap">{fmtTime(e.at)}</td>
                <td className="py-2 px-3">
                  <Tag variant="tier-3">{e.kind}</Tag>
                </td>
                <td className="py-2 px-3 text-muted">{e.source}</td>
                <td className="py-2 px-3 break-words">{e.detail}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Card>
  );
}

function Th({ children }: { children: React.ReactNode }) {
  return (
    <th className="py-2 px-3 text-[0.75rem] uppercase tracking-widest text-muted font-(family-name:--font-ui) text-left">
      {children}
    </th>
  );
}
